import MojoApiFactory from '../config/api-factory';
import { AxiosResponse } from 'axios';

export type AuthorAlias = {
  id: number;
  display_name: string;
  avatar_url: string | null;
  alias_type: string;
};

type JsonApiAuthorAlias = {
  id: string;
  type: string;
  attributes: {
    'display-name': string;
    'avatar-url': string | null;
    'alias-type': string;
  };
};

type CommentAliasesResponse = {
  data: JsonApiAuthorAlias[];
};

export const normalizeAlias = (raw: JsonApiAuthorAlias): AuthorAlias => ({
  id: Number(raw.id),
  display_name: raw.attributes['display-name'],
  avatar_url: raw.attributes['avatar-url'],
  alias_type: raw.attributes['alias-type'],
});

export const fetchCommentAliases = (): Promise<
  AxiosResponse<CommentAliasesResponse>
> => {
  return MojoApiFactory.v2.get<CommentAliasesResponse>('/comment_aliases');
};
